export const fixedColors = [
  "#EB5757",
  "#F2994A",
  "#F2C94C",
  "#219653",
  "#27AE60",
  "#6FCF97",
  "#47F6CC",
  "#66E9FB",
  "#C5D8F8",
  "#4D5DED",
  "#9B51E0",
  "#BB6BD9",
  "#D96BB5",
  "#E9888F",
  "#FE754D",
  "#FEAA4D",
  "#C6C6C6",
  "#828282",
  "#4C5058",
];
